import {
  ProductsTemplateCsvType,
  TrackingMenuClickArgs,
} from '@tiendanube/common';
import { ImportCsvEntityType } from 'commons/components';
import { logEvent } from 'commons/utils/tracking';
import {
  BACK_TO_PREVIOS_VERSION_CLICK,
  BOLD_SIGNIN_MODAL_CLICK,
  BOLD_SIGNUP_MODAL_CLICK,
  CLOUDFLARE_MIGRATION_ADBAR_CLICK,
  CSV_EXPORT_CLICK,
  CSV_IMPORT_CLICK,
  CSV_IMPORT_DOWNLOAD_TEMPLATE_CLICK,
  D2C_BOTAO_CLICK,
  DASHBOARD_BOLD_CLICK,
  DASHBOARD_GO_POS,
  DASHBOARD_KNOW_NUVEMPAGO_CLICK,
  DASHBOARD_MELI_SYNC,
  DASHBOARD_MELI_SYNC_DISMISS,
  DASHBOARD_MX_PAGO_NUBE_ACTIVATE,
  DASHBOARD_NUVEMCHAT_SETUP,
  DASHBOARD_NUVEMPAGO_SETTINGS_CLICK,
  DASHBOARD_PAYMENT_OTHERS,
  DASHBOARD_PROMOTE_TASK_CLICK,
  DASHBOARD_PROMOTE_TASK_SKIP,
  DASHBOARD_REGISTER_LOCATION,
  DASHBOARD_SALE_CHANNEL_RECOMMENDATION_CLICK,
  DASHBOARD_SEE_PREFERENCES_ENVIO_NUBE,
  DASHBOARD_SEE_PREFERENCES_NUVEM_ENVIO,
  DASHBOARD_SEE_PREFERENCES_NUVEM_PAGO,
  DASHBOARD_SEE_PREFERENCES_PAGO_NUBE,
  DASHBOARD_SEE_STORE,
  DASHBOARD_THEME_PERSONALIZE,
  HELP_TUTORIAL_CLICK,
  MENU_CONFIGURATION_CLICK,
  MENU_PRIMARY_ACCOUNT_CLICK,
  MENU_PRIMARY_SALES_CHANNEL_CLICK,
  MENU_PRIMARY_STATS_CLICK,
  MENU_STORE_VISIT,
  NUVEMPAGO_MANUAL_ACTIVATION_REGISTRATION_CAN_CLICK,
  NUVEMPAGO_MENU_CLICK,
  PRE_ONBOARDING_BACK_BUTTON_CLICK,
  PRE_ONBOARDING_CONTINUE_BUTTON_CLICK,
  PRE_ONBOARDING_RESPONSE,
  PRE_ONBOARDING_SKIP_BUTTON_CLICK,
  RECOMMENDATION_TASK_CLICK,
} from 'config/trackingEvents';
import { config } from './components/ExternalServices/Amplitude/config';

export const trackingMenuClick = (args: TrackingMenuClickArgs) => {
  logEvent(args.tag, args.options ?? {}, args.instanceName);
};

export const trackingNuvempagoMenuClick = (status: string): void => {
  logEvent(
    NUVEMPAGO_MENU_CLICK,
    { active: status },
    config.nuvempagoInstanceName,
  );
};

export const trackingNewAdminCanLinkClick = (
  previousValue: string,
  tutorial: string,
) => {
  logEvent(HELP_TUTORIAL_CLICK, {
    current_view: previousValue,
    tutorial: tutorial,
  });
};

export const trackingMenuPrimaryStatsClick = () => {
  logEvent(MENU_PRIMARY_STATS_CLICK, {});
};

export const trackingMenuConfigurationClick = () => {
  logEvent(MENU_CONFIGURATION_CLICK, {});
};

export const tranckingCloudflareMigrationAdBarClick = () => {
  logEvent(CLOUDFLARE_MIGRATION_ADBAR_CLICK, {});
};

export const trackingMenuPrimarySalesChannelClick = () => {
  logEvent(MENU_PRIMARY_SALES_CHANNEL_CLICK, {});
};

export const paymenBoldSignupModalClick = () => {
  logEvent(BOLD_SIGNUP_MODAL_CLICK, {});
};

export const paymenBoldSiginModalClick = () => {
  logEvent(BOLD_SIGNIN_MODAL_CLICK, {});
};

export const trackingMenuStoreVisit = () => {
  logEvent(MENU_STORE_VISIT, {});
};

export const trackingMenuPrimaryAccountClick = () => {
  logEvent(MENU_PRIMARY_ACCOUNT_CLICK, {});
};

export const trackingMenuD2cEvent = (
  source: 'button_click' | 'banner_click' | 'banner_close',
) => {
  logEvent(D2C_BOTAO_CLICK, { source });
};

export const nuvempagoManualActivationRegistrationCanClick = () => {
  logEvent(NUVEMPAGO_MANUAL_ACTIVATION_REGISTRATION_CAN_CLICK, {});
};

export const trackingDashboardSeeStoreClick = (): void => {
  logEvent(DASHBOARD_SEE_STORE, {});
};

export const trackingThemePersonalizeClick = (): void => {
  logEvent(DASHBOARD_THEME_PERSONALIZE, {});
};

export const trackingRegisterLocationClick = (): void => {
  logEvent(DASHBOARD_REGISTER_LOCATION, {});
};

export const trackingMeliSyncClick = (): void => {
  logEvent(DASHBOARD_MELI_SYNC, {});
};

export const trackingGoPosClick = (): void => {
  logEvent(DASHBOARD_GO_POS, {});
};

export const trackingNuvemchatSetupClick = (): void => {
  logEvent(DASHBOARD_NUVEMCHAT_SETUP, {});
};

export const trackingMeliSyncDismissClick = (): void => {
  logEvent(DASHBOARD_MELI_SYNC_DISMISS, {});
};

export const trackingSeePreferencesNuvemEnvioClick = (): void => {
  logEvent(DASHBOARD_SEE_PREFERENCES_NUVEM_ENVIO, {});
};

export const trackingSeePreferencesEnvioNubeClick = (): void => {
  logEvent(DASHBOARD_SEE_PREFERENCES_ENVIO_NUBE, {});
};

export const trackingSeePreferencesNuvemPagoClick = (): void => {
  logEvent(DASHBOARD_SEE_PREFERENCES_NUVEM_PAGO, {});
};

export const trackingMxPreferencesNubeClick = (): void => {
  logEvent(DASHBOARD_MX_PAGO_NUBE_ACTIVATE, {});
};

export const trackingSeePreferencesPagoNubeClick = (): void => {
  logEvent(DASHBOARD_SEE_PREFERENCES_PAGO_NUBE, {});
};

export const trackingPaymentOthersClick = (): void => {
  logEvent(DASHBOARD_PAYMENT_OTHERS, {});
};

export const trackingDashboardBoldClick = (): void => {
  logEvent(DASHBOARD_BOLD_CLICK, {});
};

export const trackingBackToPreviosVersionOrderListClick = (): void => {
  logEvent(BACK_TO_PREVIOS_VERSION_CLICK, {});
};

export const trackingCsvImportClick = (
  importType: string,
  template: ProductsTemplateCsvType,
  isValidTemplate: boolean,
): void => {
  logEvent(CSV_IMPORT_CLICK, {
    importType,
    template,
    isValidTemplate: String(isValidTemplate),
  });
};

export const trackingCsvImportDownloadTemplateClick = (
  entity: ImportCsvEntityType,
): void => {
  logEvent(CSV_IMPORT_DOWNLOAD_TEMPLATE_CLICK, { entity });
};

export const trackingCsvExportClick = (
  exportType: string,
  template: ProductsTemplateCsvType,
): void => {
  logEvent(CSV_EXPORT_CLICK, { exportType, template });
};

export const trackingQuestionnaireReturnClick = (
  questionType: string,
): void => {
  logEvent(PRE_ONBOARDING_BACK_BUTTON_CLICK, { questionType });
};

export const trackingQuestionnaireContinueClick = (
  questionType: string,
): void => {
  logEvent(PRE_ONBOARDING_CONTINUE_BUTTON_CLICK, { questionType });
};

export const trackingQuestionnaireSkipClick = (questionType: string): void => {
  logEvent(PRE_ONBOARDING_SKIP_BUTTON_CLICK, { questionType });
};

export const trackingQuestionnaireResponse = (
  questionGroup: string,
  questionnaireOptionResponse: string,
  freeText?: string,
): void => {
  const eventProperties: Record<string, string> = {
    questionGroup,
    questionnaireOptionResponse,
  };

  if (freeText) {
    eventProperties.free_text = freeText;
  }

  logEvent(PRE_ONBOARDING_RESPONSE, eventProperties);
};

export const trackingRecommendationClick = (
  recommendationTask: string,
): void => {
  logEvent(RECOMMENDATION_TASK_CLICK, { recommendationTask });
};

export const trackingPromoteTaskClick = (
  promoteGroup: string,
  promoteTask: string,
): void => {
  logEvent(DASHBOARD_PROMOTE_TASK_CLICK, { promoteGroup, promoteTask });
};

export const trackingPromoteTaskSkip = (
  promoteGroup: string,
  promoteTask: string,
): void => {
  logEvent(DASHBOARD_PROMOTE_TASK_SKIP, { promoteGroup, promoteTask });
};

export const trackingSaleChannelRecommendationClick = (
  saleChannel: string,
): void => {
  logEvent(DASHBOARD_SALE_CHANNEL_RECOMMENDATION_CLICK, { saleChannel });
};

export const trackingKnowNuvemPagoClick = (group: string): void => {
  logEvent(DASHBOARD_KNOW_NUVEMPAGO_CLICK, { group });
};

export const trackingNuvemPagoSettingsClick = (group: string): void => {
  logEvent(DASHBOARD_NUVEMPAGO_SETTINGS_CLICK, { group });
};
